import libConstants from '../../../../constants';
import computeTagName from '../../../../utils/computeTagName';
import computeClassName from '../../../../utils/computeClassName';
import {getValidProp} from '../../../../utils/cleanValidateStringPropValue';
import CCTabLabel from './_Label';
import CCTabStatusIndicator from './_StatusIndicator';

const SIZE_MEDIUM = 'medium';
const SIZE_LARGE = 'large';

const EXPOSURE_LOW = 'low';
const EXPOSURE_HIGH = 'high';

const TAG_DIV = 'div';

const constants = Object.freeze({
  COMPONENT_NAME: 'CCTab',

  SIZE_MEDIUM: SIZE_MEDIUM,
  SIZE_LARGE: SIZE_LARGE,
  SIZES: [SIZE_MEDIUM, SIZE_LARGE],
  SIZE_DEFAULT: SIZE_LARGE,

  EXPOSURE_LOW: EXPOSURE_LOW,
  EXPOSURE_HIGH: EXPOSURE_HIGH,
  EXPOSURES: [EXPOSURE_LOW, EXPOSURE_HIGH],
  EXPOSURE_DEFAULT: EXPOSURE_LOW,

  TAG_DEFAULT: TAG_DIV,
  CLASSNAME_BASE: 'group inline-flex flex-col items-center p-4 pb-0',
  CLASSNAME_IS_DISABLED: {
    true: {
      CLASSNAME_IS_ACTIVE: {
        true: 'cursor-auto',
        false: 'cursor-auto'
      }
    },
    false: {
      CLASSNAME_IS_ACTIVE: {
        true: 'cursor-auto',
        false: 'cursor-pointer'
      }
    }
  }
});

const propsDefaults = Object.freeze({
  size: constants.SIZE_DEFAULT,
  exposure: constants.EXPOSURE_DEFAULT,
  isActive: false,
  activationFn: null,
  activationFnArgs: undefined,
  isDisabled: false,
  tag: constants.TAG_DEFAULT
});

function getValidSize(propsSize) {
  return getValidProp(propsSize, 'size', constants.SIZE_DEFAULT, constants.SIZES, constants.COMPONENT_NAME , libConstants.LIB_DEBUG_LOGGER);
}

function getValidExposure(propsExposure) {
  return getValidProp(propsExposure, 'exposure', constants.EXPOSURE_DEFAULT, constants.EXPOSURES, constants.COMPONENT_NAME , libConstants.LIB_DEBUG_LOGGER);
}

function getComputedClassName(propsClassName) {
  return computeClassName(propsClassName, `${constants.CLASSNAME_BASE}`);
}

export default function CCTab(
  {
    label,
    size= propsDefaults.size,
    exposure= propsDefaults.exposure,
    isActive= propsDefaults.isActive,
    activationFn= propsDefaults.activationFn,
    activationFnArgs= propsDefaults.activationFnArgs,
    isDisabled= propsDefaults.isDisabled,
    tag = propsDefaults.tag,
    className = ''
  }) {
  const validSize = getValidSize(size);
  const validExposure = getValidExposure(exposure);
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = getComputedClassName(className);
  let dynamicProps = {};
  if (!isActive && !isDisabled) {
    dynamicProps['tabActivationFn'] = activationFn;
    dynamicProps['tabActivationFnArgs'] = activationFnArgs;
  }
  return (
    <ComputedTagName className={computedClassName} role="navigation">
      <CCTabLabel className="flex-grow pb-3.5"
                  tabLabel={label}
                  tabSize={validSize}
                  isTabActive={isActive}
                  isTabDisabled={isDisabled}
                  {...dynamicProps}/>
      <CCTabStatusIndicator tabExposure={validExposure}
                            isTabActive={isActive}
                            isTabDisabled={isDisabled}/>
    </ComputedTagName>
  );
}
